export default __webpack_public_path__ + "hashed/NokianTyresSans-Regular.ad920d8e.woff2";